import { useState, useEffect } from "react";
import SignaturePad from "./SignaturePad";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

export default function PVIntermediaire({ T, intervention, onClose }) {
  const [pvList, setPvList]         = useState([]);
  const [currentPV, setCurrentPV]   = useState(null);
  const [creating, setCreating]     = useState(false);
  const [saving, setSaving]         = useState(false);
  const [form, setForm]             = useState({
    travaux_effectues:"", observations:"",
    heure_debut:"", heure_fin:"",
    signature_technicien:"", signature_client:""
  });

  const load = async () => {
    const res = await fetch(`${BASE}/interventions/${intervention.id}/pv-intermediaires`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
    setPvList(Array.isArray(res)?res:[]);
  };

  useEffect(()=>{ load(); },[]);

  const openPV = (pv) => {
    setCurrentPV(pv);
    setForm({
      travaux_effectues: pv.travaux_effectues||"",
      observations: pv.observations||"",
      heure_debut: pv.heure_debut||"",
      heure_fin: pv.heure_fin||"",
      signature_technicien: pv.signature_technicien||"",
      signature_client: pv.signature_client||"",
    });
    setCreating(false);
  };

  const newPV = () => {
    setCurrentPV({numero: pvList.length+1});
    setForm({travaux_effectues:"",observations:"",heure_debut:"",heure_fin:"",signature_technicien:"",signature_client:""});
    setCreating(true);
  };

  const save = async (signe=false) => {
    setSaving(true);
    await fetch(`${BASE}/interventions/${intervention.id}/pv-intermediaires`,{
      method:"POST", headers:h(),
      body:JSON.stringify({...form, numero:currentPV.numero, signe})
    });
    await load();
    setSaving(false);
    if (signe) { setCurrentPV(null); setCreating(false); }
  };

  const upF = (k,v) => setForm(p=>({...p,[k]:v}));

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1001,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,animation:"nx-modal-open 0.3s cubic-bezier(0.16,1,0.3,1) both",width:640,maxHeight:"90vh",display:"flex",flexDirection:"column"}}>

        {/* Header */}
        <div style={{padding:"18px 22px 14px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:T.text}}>📋 PV Intermédiaires</div>
            <div style={{fontSize:12,color:T.muted,marginTop:3}}>{intervention.titre} · {pvList.length} PV enregistré(s)</div>
          </div>
          <div style={{display:"flex",gap:8}}>
            {!currentPV&&<button onClick={newPV} style={{padding:"8px 16px",borderRadius:9,background:`linear-gradient(135deg,${T.accent},${T.purple})`,border:"none",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>＋ Nouvelle journée</button>}
            <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
          </div>
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"16px 22px"}}>

          {/* Liste des PV */}
          {!currentPV&&(
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {pvList.length===0&&(
                <div style={{textAlign:"center",padding:40,color:T.muted}}>
                  <div style={{fontSize:40,marginBottom:10}}>📋</div>
                  <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:6}}>Aucun PV intermédiaire</div>
                  <div style={{fontSize:13}}>Créez un PV à la fin de chaque journée d'intervention</div>
                  <button onClick={newPV} style={{marginTop:14,padding:"10px 22px",borderRadius:10,background:T.accent,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
                    ＋ Créer le PV Jour 1
                  </button>
                </div>
              )}
              {pvList.map(pv=>(
                <div key={pv.id} onClick={()=>openPV(pv)}
                  style={{background:T.bg,border:`1.5px solid ${pv.signe?T.success:T.border}`,borderRadius:13,padding:"14px 18px",cursor:"pointer",display:"flex",alignItems:"center",gap:14,transition:"all 0.15s"}}
                  onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
                  onMouseLeave={e=>e.currentTarget.style.borderColor=pv.signe?T.success:T.border}>
                  <div style={{width:48,height:48,borderRadius:12,background:pv.signe?`${T.success}22`:`${T.accent}22`,border:`2px solid ${pv.signe?T.success:T.accent}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:800,color:pv.signe?T.success:T.accent,flexShrink:0}}>
                    J{pv.numero}
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                      <span style={{fontSize:14,fontWeight:700,color:T.text}}>Journée {pv.numero}</span>
                      <span style={{fontSize:11,fontWeight:700,color:pv.signe?T.success:T.warning,background:pv.signe?`${T.success}20`:`${T.warning}20`,padding:"2px 9px",borderRadius:20}}>
                        {pv.signe?"✅ Signé":"⏳ Non signé"}
                      </span>
                    </div>
                    <div style={{fontSize:12,color:T.muted}}>
                      📅 {new Date(pv.date_journee).toLocaleDateString("fr-FR",{weekday:"long",day:"numeric",month:"long"})}
                      {pv.heure_debut&&` · ${pv.heure_debut} → ${pv.heure_fin||"?"}`}
                    </div>
                    {pv.travaux_effectues&&<div style={{fontSize:11,color:T.mutedL,marginTop:3,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{pv.travaux_effectues}</div>}
                  </div>
                  <div style={{fontSize:20,color:T.muted}}>→</div>
                </div>
              ))}

              {pvList.length>0&&pvList.every(p=>p.signe)&&(
                <div style={{background:`${T.success}15`,border:`1px solid ${T.success}40`,borderRadius:12,padding:"13px 16px",textAlign:"center",fontSize:13,color:T.success,fontWeight:700}}>
                  ✅ Tous les PV intermédiaires sont signés · Vous pouvez clôturer l'intervention
                </div>
              )}
            </div>
          )}

          {/* Formulaire PV */}
          {currentPV&&(
            <div style={{display:"flex",flexDirection:"column",gap:16}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
                <button onClick={()=>{setCurrentPV(null);setCreating(false);}} style={{background:"none",border:"none",color:T.accent,cursor:"pointer",fontSize:13,fontWeight:600}}>← Retour</button>
                <div style={{fontSize:16,fontWeight:800,color:T.text}}>PV Journée {currentPV.numero} · {new Date().toLocaleDateString("fr-FR",{weekday:"long",day:"numeric",month:"long"})}</div>
              </div>

              {/* Heures */}
              <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:16}}>
                <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:10}}>Horaires</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                  <div>
                    <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:5}}>Heure d'arrivée</label>
                    <input type="time" value={form.heure_debut} onChange={e=>upF("heure_debut",e.target.value)}
                      style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"9px 12px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
                  </div>
                  <div>
                    <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:5}}>Heure de départ</label>
                    <input type="time" value={form.heure_fin} onChange={e=>upF("heure_fin",e.target.value)}
                      style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"9px 12px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
                  </div>
                </div>
              </div>

              {/* Travaux effectués */}
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                <label style={{fontSize:12,fontWeight:700,color:T.text}}>📝 Travaux effectués aujourd'hui *</label>
                <textarea value={form.travaux_effectues} onChange={e=>upF("travaux_effectues",e.target.value)} rows={4}
                  placeholder="Décrivez les travaux effectués durant cette journée..."
                  style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 13px",color:T.text,fontSize:13,outline:"none",resize:"vertical",lineHeight:1.6}}/>
              </div>

              {/* Observations */}
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                <label style={{fontSize:12,fontWeight:700,color:T.text}}>💬 Observations / Suite prévue</label>
                <textarea value={form.observations} onChange={e=>upF("observations",e.target.value)} rows={3}
                  placeholder="Suite à prévoir, matériaux manquants, points en attente..."
                  style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 13px",color:T.text,fontSize:13,outline:"none",resize:"vertical",lineHeight:1.6}}/>
              </div>

              {/* Signatures */}
              <SignaturePad T={T}
                label="✍️ Signature du technicien"
                hint={`Je soussigné ${intervention.technicien_nom||"le technicien"} certifie les travaux effectués ce jour`}
                value={form.signature_technicien}
                onChange={v=>upF("signature_technicien",v)}/>

              <SignaturePad T={T}
                label="🖊️ Signature du client"
                hint="Le client valide les travaux effectués durant cette journée"
                value={form.signature_client}
                onChange={v=>upF("signature_client",v)}/>

              {/* Boutons */}
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>save(false)} disabled={saving}
                  style={{flex:1,padding:"11px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>
                  💾 Sauvegarder brouillon
                </button>
                <button onClick={()=>save(true)} disabled={saving||!form.signature_technicien||!form.signature_client||!form.travaux_effectues}
                  style={{flex:2,padding:"11px",borderRadius:10,background:form.signature_technicien&&form.signature_client&&form.travaux_effectues?`linear-gradient(135deg,${T.success},#16a34a)`:T.border,border:"none",color:"#fff",fontSize:14,fontWeight:800,cursor:"pointer"}}>
                  {saving?"Enregistrement...":"✅ Signer ce PV de journée"}
                </button>
              </div>

              <div style={{padding:"11px 14px",background:T.bg,borderRadius:9,border:`1px solid ${T.border}`,fontSize:11,color:T.muted,lineHeight:1.5}}>
                📄 Ce PV intermédiaire atteste des travaux effectués le {new Date().toLocaleDateString("fr-FR")} sur l'intervention {intervention.titre} — GS-GROUP
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
